export default "__VITE_ASSET__wMz3iz_q__"